/* eslint-disable import/prefer-default-export */
import isEmpty from 'lodash/isEmpty'
import isNaN from 'lodash/isNaN'

export const parseBaseLeaseDays = (value?: (number[] | string)) => {
    if (Array.isArray(value)) return value
    if (!value) return []
    return String(value).split(';').reduce((baseLeaseAcc, el) => {
        if (!isEmpty(el)) {
            const parsedNumber = Number.parseInt(el, 10)

            if (!isNaN(parsedNumber)) baseLeaseAcc.push(parsedNumber)
        }
        return baseLeaseAcc
    }, [])
}
